var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.fonts
    ? _c("div", [
        _c("div", [
          _c(
            "ul",
            { staticClass: "font-loader" },
            _vm._l(_vm.fonts, function (fontVariant, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "font-loader-item",
                  class: ["font__" + fontVariant.slug],
                },
                [
                  _c("div", { class: fontVariant.slug }, [
                    _vm._v(_vm._s(fontVariant.name)),
                  ]),
                  _vm._v(" "),
                  fontVariant.bold == 1
                    ? _c("div", { class: fontVariant.slug + "bold" }, [
                        _vm._v("\n          1\n        "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  fontVariant.italic == 1
                    ? _c("div", { class: fontVariant.slug + "italic" }, [
                        _vm._v("\n          2\n        "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  fontVariant.italic == 1 && fontVariant.bold == 1
                    ? _c("div", { class: fontVariant.slug + "bolditalic" }, [
                        _vm._v("\n          3\n        "),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }